










import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { debounce } from 'quasar'
import Vditor from 'vditor'
import * as Y from 'yjs'
import Delta from 'quill-delta'
import stringDiffDelta from 'src/assets/stringDiffDelta'
import MarkdownEditor from 'components/MarkdownEditor.vue'

@Component({
  components: {
    MarkdownEditor
  }
})
export default class CrdtMarkdownEditor extends Vue {
  value = ''
  typing = false
  content!: Vditor

  @Prop()
  readonly text!: Y.Text

  @Prop({ default: '' } )
  readonly placeholder!: string

  @Prop({ default: false })
  readonly toolbar!: boolean

  created () {
    this.update = debounce(this.update, 1000)
  }

  mounted () {
    this.content = (this.$refs.vditor as MarkdownEditor).content
  }

  beforeDestroy () {
    this.text?.unobserve(this.observer)
  }

  @Watch('text', { immediate: true })
  init (text: Y.Text | undefined, prev: Y.Text | undefined) {
    prev?.unobserve(this.observer)
    text?.observe(this.observer)
    this.value = text?.toString() || ''
  }

  observer (event: Y.YTextEvent, transaction: Y.Transaction) {
    if (!this.typing) {
      this.value = this.text.toString()
    }
  }

  input (value: string) {
    this.typing = true
    this.update(value.trim())
  }

  update (value: string) {
    this.typing = false
    const delta = stringDiffDelta(this.value, value)
    if (delta.ops.length) {
      this.value = value
      this.$emit('update', delta)
    }
  }
}
